import { render, staticRenderFns } from "./CattleListItemCard.vue?vue&type=template&id=272c3970&scoped=true&"
import script from "./CattleListItemCard.vue?vue&type=script&lang=js&"
export * from "./CattleListItemCard.vue?vue&type=script&lang=js&"
import style0 from "./CattleListItemCard.vue?vue&type=style&index=0&id=272c3970&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272c3970",
  null
  
)

export default component.exports